import { render, staticRenderFns } from "./KpiCup.vue?vue&type=template&id=53d4c1ac&scoped=true&"
import script from "./KpiCup.vue?vue&type=script&lang=js&"
export * from "./KpiCup.vue?vue&type=script&lang=js&"
import style0 from "./KpiCup.vue?vue&type=style&index=0&id=53d4c1ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d4c1ac",
  null
  
)

export default component.exports